import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=09edf4d4&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=09edf4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09edf4d4",
  null
  
)

export default component.exports